export default {
  data() {
    return {
      currentPage: Number(this.$route.query.page) || 1,
    };
  },
  created() {
    const unwatch = this.$watch(
      () => {
        if (!this.currentPage) this.currentPage = 1;

        // The element that include this mixin must define a getData() method,
        // in order to get the data when the page changed.
        this.getData();
      }
    );
    unwatch();
  },
  methods: {
    getData(isNewSearch) {},
    pageCount(list, limitCount, totalCount = undefined) {
      const limit = limitCount ? limitCount : Number(this.$store.getters.getLimit);
      const total = list.length && list[0].counter ? list[0].counter : totalCount;

      if (total) {
        return Math.ceil(total / limit);
      }
      return 1;
    },
  },
  watch: {
    currentPage: function (newCurrentPage, oldCurrentPage) {

      if (!newCurrentPage) this.currentPage = 1;
      const query = {};

      if (this.currentPage > 1) query.page = `${this.currentPage}`;
      // if (this.brand) query.brand = `${this.brand}`;
      // if (this.cnit) query.cnit = `${this.cnit}`;
      // if (this.document_type) query.document = `${this.document_type}`;
      // if (this.energy) query.energy = `${this.energy}`;
      // if (this.gearbox_type) query.gearbox = `${this.gearbox_type}`;
      // if (this.motor_type) query.motor = `${this.motor_type}`;
      // if (this.status_document) query.status = `${this.status_document}`;
      // if (this.version) query.version = `${this.version}`;
      // Sync to URI
      this.$router.push({ query: {
        ...this.$route.query,
        page: query.page,
        // brand: query.brand,
        // cnit: query.cnit,
        // document: query.document,
        // energy: query.energy,
        // gearbox: query.gearbox,
        // motor: query.motor,
        // status: query.status,
        // version: query.version
      } });
      this.getData();
    },
    '$route.query.page': function(page) {
      if (typeof page == 'undefined')
        this.currentPage = 1;
    }
  }
};